import classNames from 'classnames/bind';
import styles from './DynamicModal.module.css';
import { IModal } from '../../../types/modal';
import Modal from '../Modal';
import { CLOSE_POPUP, DELETION_SCHEDULED_FILES } from '../../../constants';
import useModal from '../../../hooks/useModal';
import DeletionFiles from '../../../pages/Settings/Storage/DeletionFiles';
import Event from '../Event';

export default function DynamicModal({ id, type }: IModal) {
  const cx = classNames.bind(styles);
  const { toggleModal } = useModal();

  const title = {
    'deletion-scheduled-files': DELETION_SCHEDULED_FILES,
  }[id];

  const closeModal = () => toggleModal({ id, type });

  const childComponent = {
    'deletion-scheduled-files': <DeletionFiles />,
    event: <Event />,
  }[id];

  return (
    <Modal id={id} type={type}>
      <div className={cx('top')}>
        <h2 className={cx('tit')}>{title}</h2>
        <div className={cx('btn_wrap')}>
          <button
            name={CLOSE_POPUP}
            className={cx('btn', 'pop_close')}
            onClick={closeModal}
          >
            <i className={cx('svg_i')}></i>
            <span className={cx('blind')}>{CLOSE_POPUP}</span>
          </button>
        </div>
      </div>
      {childComponent}
    </Modal>
  );
}
